import Proccess from "components/common/Chart/Proccess";
import { useSelector } from "react-redux";
import './ChartProcess.scss';

interface dataItem {
  title: string,
  chartStart: {
    value: number;
    color: string;
  },
  chartEnd: {
    value: number;
    color: string;
  }
}

interface dataList extends Array<dataItem> { }

export default function ChartProcess({ data, title }: { data: dataList, title: string }) {
  const StocksAnalysisStore = useSelector((state: any) => state?.StocksAnalysisStore);

  return (
    <>
      <div className='eqDspIuAug'>{title}</div>
      <div className='FRuGQvCQGa'>
        {
          data.map((item: any, key: number) => {
            const valueStartShow = item?.chartStart?.valueShow || 0
            const valueEndShow = item?.chartEnd?.valueShow || 0

            let startValue = item?.chartStart?.value > 0 ? item?.chartStart?.value : 0;
            let endValue = item?.chartEnd?.value > 0 ? item?.chartEnd?.value : 0;

            if (startValue > 100) {
              startValue = 0
            }

            if (endValue > 100) {
              endValue = 0
            }

            if (startValue && endValue) {
              return (
                <div className='nqbrjwVzzW' key={key}>
                  <div className='ZkJBVbwyes'>{item?.title}</div>
                  <div className='zRYbvdbsBa'>
                    <div className='SLbYfJJMZE'>
                      <Proccess value={startValue} color="#F7931A" backgroundColor='transparent' height='13px' borderRadius='0' />
                      <div className='cLCWdZOVJE' style={{ left: `calc(${startValue}% + 8px)` }}>{(valueStartShow)}</div>
                    </div>
                    <div className='SLbYfJJMZE'>
                      <Proccess value={endValue} color="#22AB24" backgroundColor='transparent' height='13px' borderRadius='0' />
                      <div className='cLCWdZOVJE' style={{ left: `calc(${endValue}% + 8px)` }}>{valueEndShow}</div>
                    </div>
                  </div>
                </div>
              )
            } else {
              return null
            }
          })
        }
      </div>
      <div className="DlPnZqUEkv">
        <div className="BbWGGtZzpJ"><div className="KWBSWcuQmM" style={{ border: '2px solid #f2994a' }}></div>{StocksAnalysisStore?.inputSearch}</div>
        <div className="BbWGGtZzpJ"><div className="KWBSWcuQmM" style={{ border: '2px solid #2ad03d' }}></div>Ngành</div>
      </div>
    </>
  )
}